import { Skeleton, Stack } from "@mui/material";

export const ConfigureProductSectionLoading = () => {
  return (
    <Stack gap={2} p={2} pt={4}>
      {Array(6)
        .fill(null)
        .map((_, index) => (
          <Skeleton key={index} height={40} />
        ))}
    </Stack>
  );
};
